import { render, staticRenderFns } from "./VideoCategoriesListingContainer.vue?vue&type=template&id=b6067664"
import script from "./VideoCategoriesListingContainer.vue?vue&type=script&lang=js"
export * from "./VideoCategoriesListingContainer.vue?vue&type=script&lang=js"
import style0 from "./VideoCategoriesListingContainer.vue?vue&type=style&index=0&id=b6067664&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports